export function setupTawk(item, ctx) {
  if (window.Tawk_API) return null

  var Tawk_API = Tawk_API || {},
    _Tawk_LoadStart = new Date()
  ;(function (window, document) {
    var s1 = document.createElement('script'),
      s0 = document.getElementsByTagName('script')[0]
    s1.async = true
    s1.src = item.id
    s1.charset = 'UTF-8'
    s1.setAttribute('crossorigin', '*')
    s1.onerror = function () {
      console.warn('[Customer Service] Tawk script failed to load')
    }
    s0.parentNode.insertBefore(s1, s0)
    window.Tawk_API = Tawk_API
  })(window, document)

  let loaded = false
  let callback = null

  function TawkCall(action, param) {
    const executeAction = () => {
      try {
        switch (action) {
          case 'maximize':
            Tawk_API.maximize()
            break
          case 'minimize':
            Tawk_API.minimize()
            break
          case 'hide':
            Tawk_API.minimize()
            break
          case 'setUser':
            Tawk_API.setAttributes({ name: param }, function (error) {
              if (error) {
                console.warn('[Customer Service] Tawk setAttributes error:', error)
              }
            })
            break
          default:
            console.log('Unknown Tawk_API Action')
            break
        }
      } catch (e) {
        console.warn('[Customer Service] Tawk action error:', e)
      }
    }

    if (loaded) {
      executeAction()
    } else {
      callback = executeAction
    }
  }

  Tawk_API.onLoad = function () {
    loaded = true
    if (ctx?.tawkService) {
      ctx.tawkService.loaded = true
    }
    console.log(`[Customer Service] Tawk Ready`)
    try {
      Tawk_API.hideWidget()
    } catch (e) {
      console.warn('[Customer Service] Tawk hideWidget error:', e)
    }
    if (callback) {
      try {
        callback()
      } catch (e) {
        console.warn('[Customer Service] Tawk callback error:', e)
      }
      callback = null
    }
  }

  return {
    loaded: false,
    maximize() {
      try {
        TawkCall('maximize')
      } catch (error) {
        console.log('Tawk not ready yet')
      }
    },
    minimize() {
      try {
        TawkCall('minimize')
      } catch (error) {
        console.log('Tawk not ready yet')
      }
    },
    hide() {
      try {
        TawkCall('hide')
      } catch (error) {
        console.log('Tawk not ready yet')
      }
    },
    setUser(uidSite) {
      try {
        TawkCall('setUser', uidSite)
      } catch (error) {
        console.log('Tawk not ready yet')
      }
    },
  }
}
